import lz from 'lz-string';
import wait from 'modules/utils/wait';
import Encryption from 'services/Encryption';
import { encryptionSettings } from '../constants';
import * as types from '../types/index';

export default class StorageService {
  constructor() {
    this.hasKey = this.hasKey.bind(this);
    this.set = this.set.bind(this);
    this.get = this.get.bind(this);
    this.clear = this.clear.bind(this);
  }

  get keys(): types.StorageKey[] {
    return Object.keys(types.StorageKey).map(
      key => types.StorageKey[key as keyof typeof types.StorageKey]
    );
  }

  hasKey(key: keyof types.Storage): boolean {
    return this.keys.includes(key);
  }

  set<T extends types.Storage>(instance: T): Promise<void> {
    const compressStore = lz.compressToUTF16(JSON.stringify(instance));
    const newHex = Encryption.encrypt(
      encryptionSettings.algorithm,
      encryptionSettings.password,
      compressStore
    );
    const compressHex = lz.compressToUTF16(newHex);
    localStorage.setItem('awsdk', compressHex);
    return wait(1);
  }

  get<T extends types.Storage>(): T | {} {
    const hex = localStorage.getItem('awsdk');
    if (!hex) return {};
    const decompressHex = lz.decompressFromUTF16(hex);
    const res = Encryption.decrypt(
      encryptionSettings.algorithm,
      encryptionSettings.password,
      decompressHex
    );
    const decompressStore = lz.decompressFromUTF16(res);
    return JSON.parse(decompressStore);
  }

  clear(): void {
    localStorage.removeItem('awsdk');
  }
}
